export enum ETipoNotificacion {
  SustitucionesFinalizadas = 1
}
